import { Property, PropertyCard } from '@innovyze/stylovyze';

import { FeatureItem } from '../../utils';
import React from 'react';
import { useGlobalization } from '@Translations/useGlobalization';
import { useHistory } from 'react-router-dom';

interface IncidentPropertiesProps {
	item: FeatureItem;
}

export const IncidentProperties = ({
	item,
}: IncidentPropertiesProps): JSX.Element => {
	const { t } = useGlobalization();
	const history = useHistory();
	// useHistory returns undefined when the library's bundled react-router-dom
	// instance isn't under a Router (e.g. yalc-linked dev builds). Fall back to
	// window.location.assign so cross-microapp navigation still works.
	const navigate = (path: string) => {
		if (history) history.push(path);
		else window.location.assign(path);
	};

	const properties: Property[] = [
		{
			title: t('Incident ID', { context: 'Incident properties' }) ?? 'Incident ID',
			value: `${item.sequence}`,
			cy: 'incidentId',
		},
	];

	const goToIncident = () => {
		navigate(`/incident-management/incident/${item.id}`);
	};

	return (
		<PropertyCard
			title={item.sequence}
			properties={properties}
			menuItems={[
				{
					text: t('View Details', {
						context: 'Incident properties menu item',
					}) ?? 'View Details',
					onClick: goToIncident,
				},
			]}
			marginBottom
		/>
	);
};
